"use client";

import { I18nextProvider } from "react-i18next";
import i18n from "@/configs/i18n";
import { useEffect, useState } from "react";
import SLoadingSpinner from "@/components/atoms/SLoadingSpinner";

export default function I18nProvider({
  children,
  locale,
}: {
  children: React.ReactNode;
  locale: string;
}) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initI18n = async () => {
      setLoading(true);
      await i18n.changeLanguage(locale);
      setLoading(false);
    };

    initI18n();
  }, [locale]);

  if (loading) {
    return (
      <SLoadingSpinner wrapperClassName="flex justify-center items-center h-screen" />
    );
  }

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
